module.exports = __webpack_public_path__ + "bo.b5dd20097df8f5469ea0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bo.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bo.svg
// module chunks = styles